/**
 * Taille unique des panneaux de partage live (dossier / conversation / modèle).
 * Centralisée pour éviter les micro-divergences visuelles entre surfaces.
 */
export const SHARE_POPOVER_CONTENT_CLASSNAME =
  "w-[19rem] max-h-[calc(100vh-1rem)] overflow-y-auto p-3";
